<template>
  <div class="flex min-h-full items-center justify-center bg-canvas p-4">
    <div class="w-full max-w-sm rounded-2xl border border-line bg-surface p-7 shadow-sm">
      <div class="flex flex-col items-center text-center">
        <div class="relative size-9 shrink-0">
          <div class="absolute inset-0 rounded-lg bg-brand-600"></div>
          <div class="absolute -bottom-0.5 -right-0.5 size-3.5 rounded-sm bg-mark ring-2 ring-surface"></div>
        </div>
        <span class="mt-3 text-[15px] font-extrabold tracking-tight text-ink">Lymon</span>
        <h1 class="mt-4 text-xl font-semibold text-ink">{{ $t('login.signIn') }}</h1>
        <p class="mt-1.5 text-sm text-muted">
          {{ $t('login.subtitle') }}
        </p>
      </div>

      <Button class="mt-6" block :loading="auth.bootstrapping" @click="onSignIn">
        <template #icon><LogIn class="size-4" /></template>
        {{ auth.bootstrapping ? $t('login.connecting') : $t('login.signInWithMicrosoft') }}
      </Button>

      <div
        v-if="auth.error"
        class="mt-4 flex items-center gap-2 rounded-xl border border-danger/30 bg-danger-soft p-3 text-sm text-danger"
      >
        <TriangleAlert class="size-4 shrink-0" />{{ auth.error }}
      </div>

      <p class="mt-6 text-center text-xs text-faint">
        {{ $t('login.needAccount') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LogIn, TriangleAlert } from 'lucide-vue-next';
import { useAuthStore } from '../stores/auth';
import Button from '../components/Button.vue';

const auth = useAuthStore();

async function onSignIn(): Promise<void> {
  // loginRedirect navigates away; control returns to App.vue's
  // bootstrap() on the way back. No local state needed.
  await auth.login();
}
</script>
